<template>
  <section class="_menu-section-style">
    <form-section label="Título" v-model="isExpanded.title">
      <Texts 
        textType="title" 
        :sectionType="selectedSection.type" 
        :selectedSection="selectedSection"
        :hide="['alignment']"
      />
    </form-section>

    <form-section label="Subtítulo" v-model="isExpanded.subtitle">
      <Texts 
        textType="subtitle" 
        :sectionType="selectedSection.type" 
        :selectedSection="selectedSection"
        :hide="['alignment']"
        useTextArea
      />
      <template slot="noContent"><isEmpty/></template>
    </form-section>

    <form-section label="Patrocinadores" v-model="isExpanded.sponsors">
      <OtherTexts 
        textType="observation" 
        :sectionType="selectedSection.type" 
        :selectedSection="selectedSection"
        :hide="['alignment', 'content']"
      />
    </form-section>

    <form-section label="Fundo" v-model="isExpanded.bg">
      <Background 
        :selectedSection="selectedSection" 
        :sectionType="selectedSection.type"
        :availableTypes="['color', 'image']"
        :minValueForNumber="0"
        @update="onUpdateBackground"
      />
    </form-section>
  </section>
</template>

<script>
import FormSection from '../../_v2/utils/FormSection.vue'
import Texts from '../forms/formsV2/Texts.vue'
import OtherTexts from '../forms/formsV2/OtherTexts.vue'
import Background from '../forms/formsV2/Background.vue'
import Alignment from '../forms/formsV2/Alignment.vue'
import Media from '../forms/formsV2/Media.vue'
import isEmpty from './isEmpty.vue'

export default {
  name: 'SponsorsSection',
  components: { FormSection, Texts, OtherTexts, Background, Alignment, Media, isEmpty},
  props: {
    selectedSection: {type: Object, required: true},
    sectionsId: {type: Array, required: true}
  },

  data: () => ({
    isExpanded: {title: true, subtitle: true, sponsors: true, bg: true}    
  }),

  methods: {
    onUpdateBackground ($event) {
      this.selectedSection.bg['background-type'] = $event['background-type']
      this.selectedSection.bg['background-image'] = $event['background-image']
    }
  }    
}
</script>

<style scoped>
</style>